import { Link as WaspRouterLink, routes } from "wasp/client/router";
import { Link as RouterLink } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { useQuery, getGlobalConfig } from "wasp/client/operations";

export default function LandingNav() {
  const { data: config } = useQuery(getGlobalConfig);
  const isRegistrationEnabled = (config as any)?.registrationEnabled ?? true;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border/50">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          {/* Logo */}
          <WaspRouterLink
            to={routes.LandingPageRoute.to}
            className="flex items-center"
          >
            <span className="text-xl font-bold text-gradient-primary">
              Ottawa University
            </span>
          </WaspRouterLink>

          {/* Auth buttons */}
          <div className="flex items-center gap-3">
            <Button variant="ghost" size="sm" asChild>
              <RouterLink to={routes.LoginRoute.to}>Log in</RouterLink>
            </Button>
            {isRegistrationEnabled && (
              <Button size="sm" className="rounded-full" asChild>
                <RouterLink to={routes.SignupRoute.to}>
                  Sign up
                </RouterLink>
              </Button>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}
